<template>
    <div>
        <div class="banner about-bn">
            <!-- v-if="indexBanners.length > 0" 才會掛載swiper -->
            <swiper v-if="indexBanners.length > 0" :options="fullSwiperOption" ref="aboutSwiper" class="swiper swiper_style">
                <swiper-slide v-for="banner in indexBanners" :key="banner.id">
                    <div class="index-swiper-banner">
                        <img :src="banner" alt="">
                    </div>
                </swiper-slide>
            </swiper>
            <h2 class="title" style="z-index: 10;">高典｜歡迎回家</h2>
        </div>
        <div class="wrap">
            <section id="room-block" class="section">
                <ul class="my_ul_style">
                    <li v-for="room_type in room_types" :key="room_type.id">
                        <router-link :to="{name: 'room', params: {id: room_type.id}}">
                            <span class="my_span_1_style">
                                {{ room_type.room_type }}
                            </span>
                            <span class="my_span_2_style">
                                深入<br>了解
                            </span>
                        </router-link>
                    </li>
                </ul>
            </section>
            <section class="section intro-section">
                <div class="intro">
                    <div class="row">
                        <div class="col col2">
                            <img :src="the_img" alt="">
                        </div>
                        <div class="col col2" style="white-space: pre-line;">
                            {{ about_list.content }}
                            <!-- <p>回家的感覺是高典要營造的...<br>
                            我們不斷思考如何讓商務住宿更親近人與人之間的感覺<br>
                            商務旅人需要的是什麼?<br>
                            如家的便利<br>
                            如家的舒適<br>
                            以及<br>
                            商務人士需要的寧靜與便利<br>
                            日常起居的食衣住行我們全兼顧了<br>
                            舒適 便利 科技<br>
                            我們用最歡迎的心來迎接您，<br>
                            讓您有回家的感覺<br>
                            期待您來體驗。</p> -->
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'about',
    data () {
        return {
            fullSwiperOption: {
                loop: false,
                pagination: {
                    el: '.swiper-pagination'
                },
                effect: 'fade',
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                speed: 5000
            },
            // fullSwiperOption: {},
            indexBanners: [],
            //
            room_types: '',
            about_list: '',
            the_img: ''
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'AboutList');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('AboutList: Server Error');
            } else {
                const get_type = response.data.room_type;
                this.room_types = get_type;
                const get_list = response.data.about_list;
                this.about_list = get_list;
                const get_imgs = response.data.building_banners_url;
                this.indexBanners = JSON.parse(get_imgs);
                const get_other = response.data.image;
                this.the_img = JSON.parse(get_other);
            }
        })
        .catch(error => {
            console.log(error);
        })
    }
};
</script>

<style>
#room-block .my_ul_style{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
}
#room-block .my_ul_style li{
	flex: 0 0 20%;
	margin: 10px;
}
@media (max-width: 960px) {
	#room-block .my_ul_style li{
		flex: 0 0 40%;
	}
}
@media (max-width: 576px) {
	#room-block .my_ul_style li{
		flex: 1 0 40%;
	}
}
#room-block .my_ul_style li a{
  	display: flex;
}
#room-block .my_ul_style li a:hover {
  	color: unset;
}
#room-block .my_ul_style li .my_span_1_style,
#room-block .my_ul_style li .my_span_2_style{
	display: flex;
	justify-content: center;
	align-items: center;
    padding: 20px 5px;
}
@media (max-width: 630px) {
    #room-block .my_ul_style li .my_span_1_style,
    #room-block .my_ul_style li .my_span_2_style{
        padding: 10px;
    }
}
#room-block .my_ul_style li .my_span_1_style{
	flex: 3;
	letter-spacing: 5px;
}
#room-block .my_ul_style li .my_span_2_style{
	flex: 1;
	background-color: #b28146;
}
</style>
